import { PackagesGridWebComponent } from './component/PackagesGridWebComponent';
import { WEB_COMPONENT_PACKAGES_GRID } from '../../webcomponents.constants';

export { PackagesGridWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGES_GRID, PackagesGridWebComponent);
